import React, { forwardRef, useState, useEffect, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { useAuth } from 'hooks/useAuth';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button.js';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddressPhotoModal from './AddressPhotoModal';

import {
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
} from '@material-ui/core';

import { WithApp } from 'contexts/appContext';
import { wsGet, wsGetAll } from 'services/WService';
import useItemChanges from 'hooks/useItemChanges';

import { Polygon, Marker } from '@react-google-maps/api';
import wkt from 'wkt';
import { wsFindBy, wsUpdate, wsCreate } from 'services/WService';
import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import LayerDivitionTab from 'components/Tvendo/Common/LayerDivitionTab';
import useLayerContext from 'contexts/layerContext';
import { useModal } from 'hooks/useModal';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';
import LogsModal from 'components/Tvendo/Common/LogsModal';
import LogsModal2 from 'components/Tvendo/Common/LogsModal';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  map: {
    height: '100%',
  },
  rutaZona: {
    marginTop: '20px',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      '& h6': {
        fontSize: '14px',
        marginRight: '7px',
        marginLeft: '15px',
      },
    },
  },
}));

const defaultMapCenter = {
  lat: -14.075338295892307,
  lng: -75.73423638548219,
};
const defaultMarker = {
  lat: -14.075338295892307,
  lng: -75.73423638548219,
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * TODO Combo de rutas: Al cambiar ruta y darle a la X, el color de la ruta default no cambia a verde, pero si al darle una segunda vez
 */
export default WithApp(function AddressModal(props) {
  const classes = useStyles();
  const { hasPermission } = useAuth();

  const handleClose = () => {
    setOpen(false);
    setMapCenter(defaultMapCenter);
    setMarker(defaultMarker);
    setMarkerMoved(false);
    setAddress({});
    setAddressLoaded({});
    setUbigeoSelect({});
    setZonePolygon([]);
    setUbigeos([]);
    setRoutes([]);
  };

  const [mapRef, setMapRef] = useState(null);
  const [mapCenter, setMapCenter] = useState(defaultMapCenter);
  const [marker, setMarker] = useState(defaultMarker);
  const [markerMoved, setMarkerMoved] = useState(false);
  const [updateAddress, setUpdateAddress] = useState(false);

  const [photoModel, setPhotoOpen] = useModal();
  const [logsModel, setLogsOpen] = useModal();
  const [logsRutaModel, setRutaLogsOpen] = useModal();

  //const
  const { addressId, open, setOpen, bPartner, showNotify, layers } = props;

  const officeRouteOnly =
    bPartner?.CardType === 'C' && !!bPartner?.CardCode && !bPartner.CardCode.trim().startsWith('C');

  // const [selectedLayer, setSelectedLayer] = useState();
  const { selectedLayer, setSelectedLayer } = useLayerContext();
  const [address, setAddress] = useState({});
  const [customerRoutes, setCustomerRoutes] = useState([]);
  const [selectedCustomerRoute, setSelectedCustomerRoute] = useState();
  const [addressLoaded, setAddressLoaded] = useState({});

  const [ubigeos, setUbigeos] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [selectRoute, setSelectRoute] = useState({}); // Ruta seleccionada en el combo

  const [ubigeoSelect, setUbigeoSelect] = useState({});

  const itemChanges = useItemChanges(addressLoaded, address);
  const [disableButton, setDisableButton] = useState(false);

  async function getAddress() {
    setAddressLoaded({});
    let response = await wsGet('base/address', addressId);
    
    if (response.success) {
      if (response.data.geometry != null) {
        response.data.geometry = wkt.parse(response.data.geometry).coordinates[0].map((point) => {
          return {
            lng: point[0],
            lat: point[1],
          };
        });
      }
      
      const visualMarkerPosition = getVisualMarkerPosition(response.data);
      setMapCenter(visualMarkerPosition);
      setMarker(visualMarkerPosition);
      setMarkerMoved(false);
      setAddressLoaded(response.data);
      if (!!addressId) {
        setAddress(response.data);
        setCustomerRoutes(response.data.customer_routes);
        if (response.data.customer_routes.length > 0) {
          setSelectedCustomerRoute(response.data.customer_routes[0]);
        }
        setUbigeoSelect({
          ...response.data,
          id: response.data.base_ubigeo_id,
        });
        if (response.data.base_zone_id !== null) {
          let routes = await getRoutesByZone(response.data.base_zone_id);
          if (response.data.base_route_id !== null && routes?.length > 0) {
            const rutaFind = routes?.find(
              (route) => route.id === parseInt(response.data.base_route_id),
            );
            if (rutaFind && rutaFind.geometry !== null) setSelectRoute(rutaFind);
          }
          getZonePolygon(response.data.base_zone_id);
        } else {
          showNotify('Dirección sin zona', 'info');
        }
      } else {
        setAddress({});
      }
    }
  }

  const getVisualMarkerPosition = (addressData) => {
    if (addressData.latitude != 0 && addressData.longitude != 0) {
      return {
        lat: parseFloat(addressData.latitude),
        lng: parseFloat(addressData.longitude),
      };
    }

    if (addressData.geometry != null && Array.isArray(addressData.geometry) && addressData.geometry.length > 0) {
      return addressData.geometry[0];
    }
    
    return defaultMarker;
  };

  const getTextFieldValue = (field) => {
    if (!!addressId) {
      if (markerMoved) {
        return field === 'latitude' ? marker.lat : marker.lng;
      }
      return field === 'latitude' ? (addressLoaded.latitude || '') : (addressLoaded.longitude || '');
    } else {
      return field === 'latitude' ? 
        (!!ubigeoSelect.longitude ? ubigeoSelect.latitude : '') : 
        (!!ubigeoSelect.longitude ? ubigeoSelect.longitude : '');
    }
  };

  async function addCustomerRoute(divition, layer) {
    if (selectedCustomerRoute?.route?.id === undefined) {
      showNotify('Seleccione una ruta', 'info');
      throw new Error('Seleccione una ruta');
    }

    setDisableButton(true);
    let res = await wsCreate(`base/address/${address.id}/route`, {
      base_route_id: selectedCustomerRoute?.route?.id,
    });
    setDisableButton(false);
    if (res.success) {
      showNotify(res.message, 'success');
      setCustomerRoutes(res.data);
      setSelectedCustomerRoute(
        res.data.find((cr) => cr.route.id === selectedCustomerRoute?.route?.id),
      );
    } else {
      showNotify(res.message, 'error');
      throw new Error(res.message);
    }
  }

  async function updateCustomerRoute(data) {
    if (selectedCustomerRoute === undefined) return;
    setDisableButton(true);
    setUpdateAddress(true);
    let res = await wsUpdate(`base/address/${address.id}/route/${selectedCustomerRoute.id}`, data);
    setDisableButton(false);
    setUpdateAddress(false);
    if (res.success) {
      showNotify(res.message, 'success');
      setCustomerRoutes(res.data);
      if(selectedCustomerRoute.id !== undefined){
        setSelectedCustomerRoute(res.data.find((cr) => cr.id === selectedCustomerRoute?.id));  
      }else{
        setSelectedCustomerRoute(
          res.data.find((cr) => cr.route.id === selectedCustomerRoute?.route?.id),
        );
      }
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function getUbigeo() {
    let response = await wsGetAll('base/ubigeo');
    if (response.success) {
      setUbigeos(response.data);
    }
  }

  const [enterRoute, setEnterRoute] = useState({});
  async function getEnterRoute(coordinates) {
    if (selectedLayer === undefined) return;
    let response = await wsFindBy('base/address/route-by-lat-lng', {
      ...coordinates,
      base_layer_id: selectedLayer.id,
      base_business_partner_id: bPartner?.id,
    });
    if (response.success) {
      setEnterRoute(response.data);
      setSelectRoute(response.data);
    } else {
      setEnterRoute({ description: 'No existe ruta en este punto' });
    }
  }

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  const [zonePolygon, setZonePolygon] = useState([]);
  async function getZonePolygon(zoneId) {
    let response = await wsGet('base/zone', zoneId);
    if (response.success) {
      response.data.geometry = wkt.parse(response.data.geometry).coordinates[0].map((point) => {
        return { lng: point[0], lat: point[1] };
      });
      setZonePolygon(response.data.geometry);

      response.data.routes.map((obj) => {
        if (obj.geometry != null) {
          obj.geometry = wkt.parse(obj.geometry).coordinates[0].map((point) => {
            return { lng: point[0], lat: point[1] };
          });
        }
        return obj;
      });
      setRoutes(response.data.routes);
    }
  }

  const [routesByZone, setRoutesByZone] = useState([]);
  async function getRoutesByZone(zoneId) {
    const response = await wsFindBy(officeRouteOnly ? 'base/route/office' : 'base/route', 'base_zone_id', zoneId);
    if (response.success) {
      setRoutesByZone(response.data);
    } else {
      showNotify(response.message, 'error');
    }

    return response.data;
  }

  const handleSaveEdit = () => {
    if (itemChanges) {
      let route = {};
      if (enterRoute.id != undefined) {
        route = { base_route_id: enterRoute.id };
      }
      saveAddress({
        ...itemChanges,
        latitude: getTextFieldValue('latitude').toString(),
        longitude: getTextFieldValue('longitude').toString(),
        ...route,
      });
    } else {
      handleClose();
    }
  };

  /**
   * Address2 es un campo de 50
   * Street de 100
   * Al editar tiene que mostrarse Street
   * En el backendse seteea Street con 100 y address con substring de 50
   */
  const handleChange = (e) => {
    if (e.target.name === 'Address2') {
      setAddress({
        ...address,
        Address2: e.target.value,
        Street: e.target.value,
      });
    } else {
      setAddress({
        ...address,
        [e.target.name]: e.target.value,
      });
    }
  };

  //Guardar direccion
  async function saveAddress(data) {
    if (address.AdresType === 'S') {
      if (selectedLayer === undefined) {
        showNotify('Seleccione una capa', 'info');
        return;
      }
      data.base_layer_id = selectedLayer.id;
    }
    if (data.base_route_id !== undefined) {
      delete data.base_route_id;
    }
    setDisableButton(true);
    setUpdateAddress(true);
    if (ubigeoSelect.id !== undefined) {
      data.base_ubigeo_id = ubigeoSelect.id;
    }

    let response;
    if (!!addressId) {
      response = await wsUpdate('base/address', addressId, data);
    } else {
      response = await wsCreate('base/address', data);
    }
    if (response.success) {
      setOpen(false);
      if (!!props.reload) {
        props.reload();
      }
      showNotify(response.message);
    } else {
      setDisableButton(false);
      setUpdateAddress(false);
      showNotify(response.message, 'error');
    }
  }
  // DATOS ORDENADOS
  const filteredRoutes = useMemo(() => {
    const list = selectedLayer === undefined
      ? routes
      : routes.filter((route) => route.layer.id === selectedLayer.id);

    return [...list].sort((a, b) => a.description.localeCompare(b.description));
  }, [routes, selectedLayer]);
  const routeOptions = officeRouteOnly ? routesByZone : filteredRoutes;

  useEffect(() => {
    if (selectRoute?.id !== undefined) {
      const layerMatch = layers.find(l => l.id === selectRoute.layer.id);
      if (layerMatch) setSelectedLayer(layerMatch);
    }
  }, [selectRoute, layers]);

  useEffect(() => {
    if (!!addressId) {
      getAddress();
    }
    if (open) {
      getUbigeo();
      listZones();
      setAddress({});
      setUbigeoSelect({});
      setMapCenter(defaultMapCenter);
      setMarker(defaultMarker);
    }
  }, [open]);

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <LogsModal
        logName="base_addresses"
        subjectId={addressId}
        model={logsModel}
        setOpen={setLogsOpen}
      />
      <LogsModal2
        logName="base_customer_routes"
        subjectId={selectedCustomerRoute?.id}
        model={logsRutaModel}
        setOpen={setRutaLogsOpen}
      />
      <AddressPhotoModal
        model={photoModel}
        setOpen={setPhotoOpen}
        showNotify={showNotify}
        setAddress={setAddress}
      />
      <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              style={{ color: 'white' }}
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {bPartner.CardCode} - {bPartner.CardName}
              <br />
              {!!address?.Address2
                ? `Dirección: ${address.Street || address.Address2}`
                : 'Nueva dirección'}
            </Typography>
          </Toolbar>
        </AppBar>
        <GridItem xs={12} sm={12} md={12} className={classes.rutaZona} style={{ marginTop: 0 }}>
          <span>
            <h6>Ruta: </h6>
            {address.base_route_description}
            <h6>Zona: </h6>
            {address.base_zone_description}
            <h6>Polygon: </h6>
            {enterRoute.description}
          </span>
        </GridItem>
        <GridItem xs={12} sm={12} md={6} className={classes.map}>
          <GoogleMapCustom
            onLoad={(map) => {
              setMapRef(map);
            }}
            mapContainerStyle={{
              width: '100%',
              height: '100%',
              minHeight: '600px',
            }}
            zoom={14}
            center={mapCenter}
            onDragEnd={() => {
              if (!mapRef) return;
              let center = {
                lat: mapRef.center.lat(),
                lng: mapRef.center.lng(),
              };
              setMapCenter(center);
            }}
          >
            {/* Zona */}
            <Polygon
              options={{
                fillColor: '#f7fcd1',
              }}
              paths={zonePolygon}
            />
            {filteredRoutes?.map((obj, i) => {
              if (obj.geometry === null) {
                return;
              }
              return obj !== null ? (
                <Polygon
                  options={{
                    fillColor: selectRoute.id === obj.id ? undefined : obj.layer.color,
                  }}
                  paths={obj.geometry}
                  key={i}
                />
              ) : undefined;
            })}

            {!!marker ? (
              <AllowedGuard
                permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                component={<Marker position={marker} />}
              >
                <Marker
                  draggable
                  position={marker}
                  onDragEnd={(e) => {
                    const newPosition = {
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    };

                    setMarker(newPosition);
                    setMarkerMoved(true);
                    setUbigeoSelect({
                      ...ubigeoSelect,
                      latitude: newPosition.lat,
                      longitude: newPosition.lng,
                    });
                    getEnterRoute({
                      latitude: newPosition.lat,
                      longitude: newPosition.lng,
                    });
                  }}
                />
              </AllowedGuard>
            ) : undefined}
          </GoogleMapCustom>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12}>
              <LayerLegend extraLayers={[{ color: '#000000', name: 'Ruta actual' }]} />
            </GridItem>
          </GridContainer>

          {/* Cliente Ruta */}
          {address.AdresType === 'S' && (
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
              component={
                <fieldset>
                  <legend style={{ margin: 0 }}>Rutas</legend>
                  {customerRoutes.length > 0 ? (
                    <ul>
                      {customerRoutes.map((customerRoute) => (
                        <li key={customerRoute.id}>
                          {customerRoute.divition?.name
                            ? `${customerRoute.divition.name}: `
                            : ''}
                          {customerRoute.route?.description || 'Sin ruta asignada'}
                          {customerRoute.state
                            ? ` - ${customerRoute.state === 'A' ? 'Activo' : 'Inactivo'}`
                            : ''}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Typography>Sin rutas asociadas</Typography>
                  )}
                </fieldset>
              }
            >
              <fieldset>
                <legend style={{ margin: 0 }}>Rutas</legend>
              <GridContainer>
                <GridItem xs={12}>
                  <LayerDivitionTab
                    disabled={disableButton}
                    customerRoutes={customerRoutes}
                    addPermission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                    onCustomerRouteChange={(customerRoute) => {
                      setSelectedCustomerRoute(customerRoute);
                      setEnterRoute(customerRoute?.route || {});
                      setSelectRoute(customerRoute?.route || {});
                    }}
                    onAddDivition={addCustomerRoute}
                    address={address}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <GridContainer>
                    {/* Zona */}
                    <GridItem xs={4}>
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Zona</InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          value={address.base_zone_id || ''}
                          inputProps={{
                            name: 'base_zone_id',
                            onChange: handleChange,
                          }}
                          disabled={disableButton || !!props.disabled}
                        >
                          {zones.map((zone, i) => {
                            return (
                              <MenuItem
                                value={zone.id}
                                key={i}
                                onClick={() => {
                                  getRoutesByZone(zone.id);
                                  if (zone.latitude) {
                                    setMapCenter({ lat: zone.latitude, lng: zone.longitude });
                                    if (
                                      Object.keys(addressLoaded).length === 0 ||
                                      addressLoaded.latitude == '0'
                                    ) {
                                      setMarker({ lat: zone.latitude, lng: zone.longitude });
                                    }
                                  } else {
                                    showNotify(
                                      'No tiene coordenadas para centrar el mapa y marcador',
                                      'info',
                                    );
                                  }
                                  if (zone.geometry !== null) getZonePolygon(zone.id);
                                }}
                              >
                                {zone.description}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </GridItem>
                    {/* Ruta */} 
                    <GridItem xs={4}>
                      <Autocomplete
                        key={routeOptions}
                        options={routeOptions}
                        getOptionLabel={(option) => option.description}
                        disabled={disableButton}
                        value={
                          routesByZone.find(
                            (item) => item.id === selectedCustomerRoute?.route?.id,
                          ) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Ruta"
                            margin="normal"
                            placeholder="Selecciona una zona para listar rutas"
                          />
                        )}
                        onChange={(e, item) => {
                          if (item !== null && selectedCustomerRoute?.id !== undefined) {
                            updateCustomerRoute({ base_route_id: item.id, latitude: marker.lat,longitude: marker.lng });
                            return;
                          }

                          if (!!item) {
                            setSelectRoute(item);
                            setSelectedCustomerRoute((cr) => ({ ...cr, route: item }));
                            if (item.geometry == null) {
                              showNotify('Ruta sin polígono', 'info');
                            }
                          } else {
                            setAddress({ ...address, base_route_id: null });
                            setSelectedCustomerRoute((cr) => ({ ...cr, route: undefined }));
                            setSelectRoute({});
                          }
                        }}
                      />
                    </GridItem>
                    {/* Estado */}
                    <GridItem xs={4}>
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Estado</InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          value={selectedCustomerRoute?.state || 'A'}
                          disabled={disableButton || selectedCustomerRoute?.id === undefined}
                          onChange={(e) => updateCustomerRoute({ state: e.target.value })}
                        >
                          <MenuItem value="A">Activo</MenuItem>
                          <MenuItem value="I">Inactivo</MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              </fieldset>
            </AllowedGuard>
          )}

          {/* Dirección */}
          <fieldset style={{ marginTop: '15px' }}>
            <legend style={{ margin: 0 }}>Dirección</legend>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                if (!hasPermission(ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE)) {
                  return;
                }
                if (!!addressId) {
                  handleSaveEdit();
                } else {
                  saveAddress({
                    ...address,
                    base_business_partner_id: bPartner.id,
                    latitude: getTextFieldValue('latitude').toString(),
                    longitude: getTextFieldValue('longitude').toString(),
                  });
                }
              }}
            >
              <GridContainer>
                {address.photos !== undefined && address.AdresType === 'S' && (
                  <>
                    <GridItem xs={12}>
                      <InputLabel>
                        Fotos <small style={{ fontSize: '10px' }}>(Max 5)</small>
                      </InputLabel>
                    </GridItem>
                    <GridItem xs={12} style={{ position: 'relative' }}>
                      <div
                        style={{
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                          }}
                        >
                          {address.photos.map((photo) => {
                            return (
                              <div
                                key={photo.id}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  borderRadius: '5px',
                                  border: '1px solid black',
                                  marginRight: '5px',
                                  cursor: 'pointer',
                                  backgroundImage: `url(${photo.file_url})`,
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundPosition: 'center',
                                }}
                                onClick={() => {
                                  setPhotoOpen({ ...address, ...photo });
                                }}
                              ></div>
                            );
                          })}
                          {address.photos.length <= 4 && (
                            <AllowedGuard
                              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                            >
                              <div
                                style={{
                                  width: '100px',
                                  height: '100px',
                                }}
                              >
                                <Button
                                  style={{
                                    width: '100px',
                                    height: '100%',
                                    margin: '0',
                                  }}
                                  color="success"
                                  onClick={() => {
                                    setPhotoOpen({
                                      ...address,
                                      id: undefined,
                                      base_address_id: address.id,
                                    });
                                  }}
                                >
                                  Agregar
                                </Button>
                              </div>
                            </AllowedGuard>
                          )}
                        </div>
                      </div>
                    </GridItem>
                  </>
                )}

                <GridItem xl={6}>
                  <TextField
                    label="ID domicilio"
                    fullWidth
                    name="domicilio_id"
                    margin="normal"
                    size="small"
                    value={address.domicilio_id || ''}
                    onChange={handleChange}
                    disabled
                  />
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Tipo</InputLabel>
                    <Select
                      value={address.AdresType || 'S'}
                      inputProps={{ name: 'AdresType' }}
                      disabled
                    >
                      <MenuItem value="B">Fiscal</MenuItem>
                      <MenuItem value="S">Entrega</MenuItem>
                    </Select>
                  </FormControl>
                  <AllowedGuard
                    permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                    component={
                      <>
                        <TextField
                          label="Dirección"
                          fullWidth
                          margin="normal"
                          size="small"
                          value={address.Street || address.Address2 || ''}
                          disabled
                        />
                        <TextField
                          label="Referencia"
                          fullWidth
                          margin="normal"
                          size="small"
                          value={address.adress_reference || ''}
                          disabled
                        />
                      </>
                    }
                  >
                    <TextField
                      label="Dirección"
                      fullWidth
                      name="Address2"
                      margin="normal"
                      size="small"
                      value={address.Street || address.Address2 || ''}
                      onChange={handleChange}
                      required
                      disabled={!!props.disabled}
                    />
                    <TextField
                      label="Referencia"
                      fullWidth
                      name="adress_reference"
                      margin="normal"
                      size="small"
                      value={address.adress_reference || ''}
                      onChange={handleChange}
                      disabled={!!props.disabled}
                    />
                  </AllowedGuard>

                  {!!addressId ? (
                    <TextField
                      label="Latitud"
                      fullWidth
                      name="latitude"
                      margin="normal"
                      size="small"
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={getTextFieldValue('latitude')}
                    />
                  ) : (
                    <TextField
                      label="Latitud"
                      fullWidth
                      name="latitude"
                      margin="normal"
                      size="small"
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={!!ubigeoSelect.longitude ? ubigeoSelect.latitude : ''}
                    />
                  )}
                  <AllowedGuard
                    permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                    component={
                      <TextField
                        label="Estado"
                        fullWidth
                        margin="normal"
                        size="small"
                        value={address.state === 'I' ? 'Inactivo' : 'Activo'}
                        disabled
                      />
                    }
                  >
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Estado</InputLabel>
                      <Select
                        value={address.state || 'A'}
                        inputProps={{
                          name: 'state',
                          onChange: handleChange,
                        }}
                        disabled={!!props.disabled}
                      >
                        <MenuItem value="A">Activo</MenuItem>
                        <MenuItem value="I">Inactivo</MenuItem>
                      </Select>
                    </FormControl>
                  </AllowedGuard>
                </GridItem>
                <GridItem xl={6}>
                  <AllowedGuard
                    permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                    component={
                      <TextField
                        label="Ubigeo"
                        fullWidth
                        margin="normal"
                        size="small"
                        value={
                          ubigeoSelect.U_SYP_DEPA
                            ? `${ubigeoSelect.U_SYP_DEPA}, ${ubigeoSelect.U_SYP_PROV}, ${ubigeoSelect.U_SYP_DIST}`
                            : ''
                        }
                        disabled
                      />
                    }
                  >
                    <Autocomplete
                      options={ubigeos}
                      value={ubigeos.Code}
                      getOptionLabel={(option) => {
                        return `${option.U_SYP_DEPA}, ${option.U_SYP_PROV}, ${option.U_SYP_DIST}`;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Buscar ubigeo..."
                          margin="normal"
                          size="small"
                        />
                      )}
                      onChange={(e, item) => {
                        if (!!item) {
                          setUbigeoSelect(item);
                          setAddress({
                            ...address,
                            base_ubigeo_id: item.id,
                          });
                          if (item.latitude) {
                            setMapCenter({ lat: item.latitude, lng: item.longitude });
                            if (
                              Object.keys(addressLoaded).length === 0 ||
                              addressLoaded.latitude == '0'
                            ) {
                              setMarker({ lat: item.latitude, lng: item.longitude });
                            }
                          } else {
                            showNotify(
                              'No tiene coordenadas para centrar el mapa y marcador',
                              'info',
                            );
                          }
                        } else {
                          setUbigeoSelect({});
                          setAddress({
                            ...address,
                            base_ubigeo_id: null,
                          });
                        }
                      }}
                    />
                  </AllowedGuard>
                  <TextField
                    label="Departamento"
                    fullWidth
                    name="County"
                    margin="normal"
                    size="small"
                    value={ubigeoSelect.U_SYP_DEPA || ''}
                    onKeyDown={() => false}
                    required
                  />
                  <TextField
                    label="Provincia"
                    fullWidth
                    name="City"
                    margin="normal"
                    size="small"
                    onKeyDown={() => false}
                    value={ubigeoSelect.U_SYP_PROV || ''}
                    required
                  />
                  <TextField
                    label="Distrito"
                    fullWidth
                    name="Block"
                    margin="normal"
                    size="small"
                    onKeyDown={() => false}
                    value={ubigeoSelect.U_SYP_DIST || ''}
                    required
                  />

                  {!!addressId ? (
                    <TextField
                      label="Longitud"
                      fullWidth
                      name="longitude"
                      margin="normal"
                      size="small"
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={getTextFieldValue('longitude')}
                    />
                  ) : (
                    <TextField
                      label="Longitud"
                      fullWidth
                      name="longitude"
                      margin="normal"
                      size="small"
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={!!ubigeoSelect.longitude ? ubigeoSelect.longitude : ''}
                    />
                  )}

                  <AllowedGuard
                    permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                  >
                    <AllowedGuard permission={ConstantPermissions.BASE_ADDRESSES_LOCKED_UPDATE}>
                      <FormControlLabel
                        label="Bloquear actualizaciones gps"
                        control={
                          <Checkbox
                            margin="normal"
                            checked={address.locked === undefined ? false : address.locked}
                            onChange={(e) => {
                              setAddress((address) => ({
                                ...address,
                                locked: e.target.checked,
                              }));
                            }}
                          />
                        }
                      />
                    </AllowedGuard>
                  </AllowedGuard>
                  <Button color="primary" onClick={() => setLogsOpen({})}>
                    Logs Dirección
                  </Button>
                  <Button color="info" onClick={() => setRutaLogsOpen({})}>
                    Logs Ruta
                  </Button>
                </GridItem>
                <GridItem xl={12}>
                  <div style={{ float: 'right', marginTop: '15px' }}>
                    <AllowedGuard
                      permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                    >
                      <Button
                        type="submit"
                        color={props.themeContext.buttonColorSuccess}
                        disabled={
                          updateAddress ||
                          (address.AdresType === 'B'
                            ? false
                            : address.id === undefined
                            ? false
                            : disableButton || selectedCustomerRoute?.id === undefined)
                        }
                      >
                        Guardar
                      </Button>
                    </AllowedGuard>
                    <Button color={props.themeContext.buttonColorDanger} onClick={handleClose}>
                      Cancelar
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
            </form>
          </fieldset>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
});
